import * as type from "./types";
import _ from "lodash";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_ROSTER_PERIOD:
      return { ..._.mapKeys(action.payload, "value") };
    case type.CREATE_ROSTER_PERIOD:
      return { ...state, ..._.mapKeys(action.payload, "value") };
    case type.DELETE_ROSTER_PERIOD:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
export const RosterDDL = (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_ROSTER_DDL:
      return action.payload;
    default:
      return state;
  }
};
